export enum EmailTypes {
    email = 1,
    document_request = 2,
    signature_request = 3,
    approval_request = 4,
    survey = 5,
    payment_request = 6,
    appointment_request = 11,
    question_request = 12,
    checklist_request = 14
}

